import styled from 'styled-components/macro';
import Button from '~/components/Button';
import images from '~/constants/images';

export const FormContainer = styled.div`
  width: ${({ width }) => width || 100}%;
  min-width: 330px;
  display: flex;
  flex-direction: column;
  max-width: ${({ maxWidth }) => maxWidth || '100%'};

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    width: 100%;
    height: ${props => (props.height ? props.height : '100vh')};
    min-width: 0;
  }
`;

export const Form = styled.form`
  display: ${({ flex }) => (flex ? 'flex' : 'grid')};
  ${({ flex }) =>
    flex
      ? 'flex-direction: column;align-items: center;justify-content: center;'
      : 'grid-column-gap: 40px;'};
  justify-content: ${({ position }) => position || 'center'};
  ${({ columns }) =>
    columns === 2
      ? `grid-template-columns: calc(50% - 20px) calc(50% - 20px);`
      : ``};
  width: ${({ hasWidth }) => hasWidth || 100}%;
  min-width: 320px;
  border: 10px solid ${({ theme }) => theme.mainGrey};
  padding: 20px 60px;
  background-color: ${({ theme }) => theme.white};
  ${({ areas }) => areas && areas.lg && `grid-template-areas: ${areas.lg};`};

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    align-content: start;
    border: 0;
    height: ${props =>
      props.hasHeight ? props.hasHeight : 'calc(100vh - 130px)'};
    padding: 5%;
    ${({ columns }) => (columns === 2 ? `grid-template-columns:100%;` : ``)}
    ${({ areas }) => areas && areas.xs && `grid-template-areas: ${areas.xs};`}
  }
`;

export const ErrorMessage = styled.p`
  font-family: ${({ theme }) => theme.primaryFontMedium};
  color: ${({ theme }) => theme.dangerLight};
  font-size: ${({ theme }) => theme.label}px;
  line-height: 11px;
  padding: 5px;
  opacity: ${({ shouldShow }) => (shouldShow ? 1 : 0)};
  transition: opacity 0.3s;
  height: auto;
  width: 100%;
  margin-top: ${({ forcePosition }) => (forcePosition ? -10 : 0)}px;
`;

export const FormHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: auto;
`;

export const Logo = styled.div`
  width: 100%;
  height: ${({ vertical }) => (!vertical ? 50 : 80)}px;
  background-image: ${({ vertical }) =>
    `url(${
      !vertical ? images.logoBlackHorizontal : images.logoBlackVertical
    })`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 34px;
`;

export const FormTitle = styled.p`
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: ${({ theme }) => theme.h4}px;
  width: 100%;
  text-align: center;
  margin: 10px 0;
`;

export const FormSubtitle = styled.p`
  font-family: ${({ theme }) => theme.primaryFontLight};
  font-size: ${({ theme }) => theme.paragraph}px;
  width: 100%;
  text-align: center;
  margin: 10px 0 0;
  color: ${({ theme }) => theme.dark};
`;

export const ConfirmationSuccessMessage = styled.p`
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: ${({ theme }) => theme.h5}px;
  color: ${({ theme }) => theme.blue};
  width: 100%;
  text-align: center;
`;

export const SubmitButton = styled(Button)`
  width: 304px;
  min-height: 40px;
  border-style: none;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.gray : theme.headerBlack};
  font-family: ${({ theme }) => theme.primaryFontBold};
  color: ${({ theme, disabled }) => (disabled ? theme.gray2 : theme.light)};
  transition: color 0.3s, background-color 0.3s;
  margin: 5px 0 10px;
`;

export const CancelButton = styled(Button)`
  width: 304px;
  height: 40px;
  border-style: none;
  background-color: transparent;
  color: ${({ theme, disabled }) => (disabled ? theme.gray2 : theme.dark)};
  transition: color 0.3s, background-color 0.3s;
  margin: 0 0 10px;
`;

export const Advice = styled.p`
  width: 100%;
  text-align: center;
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.paragraph}px;
  margin-bottom: 10px;
`;

export const LoginZone = styled.div`
  width: 100%;
  padding: 10px;
  display: flex;
  align-items: center;
  border-left: 10px solid ${({ theme }) => theme.mainGrey};
  border-right: 10px solid ${({ theme }) => theme.mainGrey};
  border-bottom: 10px solid ${({ theme }) => theme.mainGrey};
  background-color: ${({ theme }) => theme.white};

  p {
    width: 50%;
    font-family: ${({ theme }) => theme.primaryFontBold};
    font-size: ${({ theme }) => theme.h5}px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  div {
    width: 50%;
    padding: 5px;
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      max-width: 270px;
      height: 40px;
      font-family: ${({ theme }) => theme.primaryFontMedium};
      font-size: ${({ theme }) => theme.button}px;
      padding: 3px;
      border-style: none;
      background-color: ${({ theme, disabled }) =>
        disabled ? theme.gray : theme.dark};
      color: ${({ theme, disabled }) => (disabled ? theme.gray2 : theme.light)};
      transition: color 0.3s, background-color 0.3s;
      margin: 0;
    }
    button {
      background-color: 'black';
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    border: 0;
    height: 130px;
    background-color: ${({ theme }) => theme.mainGrey};
    display: flex;
    align-items: center;
    padding: 0;
    justify-content: center;
    position: relative;
    flex-direction: column;

    &:before {
      content: ' ';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.1;
      background-image: url(${images.beat});
      background-repeat: no-repeat;
      background-position: center 110%;
      z-index: 0;
    }

    p {
      color: ${({ theme }) => theme.dark};
    }

    > div {
      display: flex;
      justify-content: center;
      z-index: 5;
    }
  }
`;

export const RegisterZone = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-left: 10px solid ${({ theme }) => theme.mainGrey};
  border-right: 10px solid ${({ theme }) => theme.mainGrey};
  border-bottom: 10px solid ${({ theme }) => theme.mainGrey};
  background-color: ${({ theme }) => theme.white};

  p {
    width: 100%;
    font-family: ${({ theme }) => theme.primaryFontBold};
    font-size: ${({ theme }) => theme.h4}px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
  }
  div {
    width: 100%;
    padding: 5px;
    display: flex;
    justify-content: center;
    a,
    button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      max-width: 304px;
      height: 40px;
      font-family: ${({ theme }) => theme.primaryFontBold};
      font-size: ${({ theme }) => theme.button}px;
      padding: 3px;
      border-style: none;
      background-color: ${({ theme, disabled }) =>
        disabled ? theme.gray : theme.headerBlack};
      color: ${({ theme, disabled }) => (disabled ? theme.gray2 : theme.light)};
      transition: color 0.3s, background-color 0.3s;
      margin: 0;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    border: 0;
    height: 130px;
    background-color: ${({ theme }) => theme.white};
    display: flex;
    align-items: center;
    padding: 0;
    justify-content: center;
    position: relative;

    &:before {
      content: ' ';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.1;
      background-image: url(${images.beat});
      background-repeat: no-repeat;
      background-position: center 110%;

      z-index: 0;
    }

    p {
      color: ${({ theme }) => theme.light};
    }

    > div {
      z-index: 5;
    }
  }
`;

export const Return = styled.div`
  width: 100%;
  display: flex;
  font-family: ${({ theme }) => theme.primaryFontMedium};
  justify-content: center;
  a {
    color: ${({ theme }) => theme.headerBlack};
    font-family: ${({ theme }) => theme.primaryFont};
  }
`;

export const SmallNotification = styled.p`
  width: 100%;
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.label}px;
  color: ${({ theme }) => theme.dark2};
  margin: 0 0 10px;
`;

export const Aligner = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const checkboxText = styled.label`
  width: calc(100% - 30px);
  font-size: ${({ theme }) => theme.label}px;
  position: absolute;
  left: 30px;
  top: 8px;

  span {
    font-family: ${({ theme }) => theme.primaryFontBold};
    text-decoration: underline;
    cursor: pointer;
  }
`;
